// Chakra imports
import {
  Box,
  Flex, HStack, keyframes, Progress,
  Text,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import React from "react";

const blink = keyframes`
    0% {
        opacity: 0.2;
    }
    20% {
        opacity: 1;
    }
    100% {
        opacity: 0.2;
    }
`;

const LoadingData = () => {
  return (
    <Card
      w={{sm: "100%", lg: "70%"}}
      alignSelf={{lg: "flex-end"}}
      justifySelf={{lg: "flex-end"}}
    >
      <Progress size="xs" isIndeterminate/>
      <CardBody>
        <Flex
          direction={{sm: "column", md: "row"}}
          justify="space-between"
          align="center"
          w="100%"
        >
          <Flex align="center">
            <Text py={5} color="blackAlpha.700" fontWeight="bold" fontSize="md">
              Wij zijn uw gegevens aan het ophalen, een moment geduld
              {Array.from({length: 3}).map((_, i) => (
                <Box
                  key={i}
                  as="span"
                  display="inline-block"
                  ml="1"
                  w="4px"
                  h="4px"
                  borderRadius="full"
                  bg="blackAlpha.700"
                  animation={`${blink} 1.4s infinite`}
                  animationDelay={`${i * 0.2}s`}
                />
              ))}
            </Text>
          </Flex>
          <Flex
            align="center"
            alignSelf={{sm: "flex-start", lg: null}}
            mt={{sm: "16px", lg: null}}
            ms={{sm: "6px", lg: null}}
          >
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  );
};

export default LoadingData;
